module.exports = __webpack_public_path__ + "img/gdrive_logo.17e1ce01.png";